import axios from 'axios';
import Swal from 'sweetalert2';
import { fetchAllPositionSkills } from './fetchAllPositionSkills';

export function addPositionSkillBulk(positionId, params) {
  return (dispatch) => {
    return axios
      .post(`/position/${positionId}/skills`, params)
      .then((response) => {
        const { status } = response.data;
        if (status === 'SUCCESS') {
          Swal.fire({
            title: 'Success',
            text: 'Successfully bulk added skills',
            icon: 'success',
            confirmButtonColor: '#3f51b5',
          });
          dispatch(fetchAllPositionSkills(positionId));
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
}
